(function () {
  'use strict';

  angular.module('app').component('billList', billList());

  function billList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalAmounts: '<',
        totalItems: '=',
        onShowBill: '&',
      },
      controller: BillListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bills/bill-list/bill-list.component.html',
    };
  }

  BillListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'BillService',
    'DocumentService',
  ];

  function BillListCtrl(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    BillService,
    DocumentService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_bill_accountadmin'),
      canUpdate: AbilityService.can('update_bill_accountadmin'),
      canDestroy: AbilityService.can('destroy_bill_accountadmin'),
    };

    vm.billStatuses = angular.copy(config.BILL_STATUSES);
    vm.billStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.atvCrStatuses = angular.copy(config.ATV_CR_STATUSES);
    vm.atvCrStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.statusDraft = 'draft';
    vm.statusPaid = 'paid';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    const apiUrl = 'bill_reports';
    vm.urlXls = apiUrl + '/export_purchases_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_purchases_pdf.pdf';
    vm.reportName = 'bills_report';

    // private properties
    // -----------------------
    const company = SessionService.getSelectedAccountCompany();

    // const dateDisplay = config.DATE_DISPLAY_SHORT;
    let userLanguageCode = SessionService.getUserLanguage().code;
    let dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      setBills(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
      setDueDatePicker();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      BillService.getBills(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalAmounts = vm.items.totalAmounts;

        setBills(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowBill({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      BillService.deleteBill(item, vm.fetchResult);
    };

    // Atv functions
    vm.sendDocumentToAtv = function (item) {
      if (!item.canSend) return;

      vm.loadingDocument = true;
      DocumentService.sendDocumentToAtv(item, 'bills').then(function (data) {
        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.resendDocumentToAtv = function (item) {
      if (!item.canResend) return;

      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(item, 'bills').then(function (data) {
        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.downloadBillPdf = function (item) {
      BillService.downloadBillPdf(item, userLanguageCode);
    };

    vm.openRelatedTransactions = function (item) {
      BillService.openRelatedTransactions(item, item.provider);
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearDueDate = function () {
      vm.dueDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_due_date_from;
      delete vm.filterCriteria.by_due_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();

      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setBills(items) {
      // items.map((item) => {
      items.forEach((item) => {
        item.date = moment(item.date).format(dateDisplay);
        item.bill_number = item.bill_number || '-';
        item.provider_name = item.provider.name + ' ' + item.provider.last_name;
        item.due_date_label = item.due_date; // for status
        item.due_date = item.due_date ? moment(item.due_date).format(dateDisplay) : item.date;

        validateItemActions(item);
      });
    }

    function validateItemActions(item) {
      item.canEdit =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.status === 'draft'));
      item.canDelete = vm.permissions.canDestroy && item.status === 'draft';

      item.canSend =
        vm.permissions.canUpdate &&
        vm.atvCrEnabled &&
        item.document_type.numbering_type === 'electronic' &&
        item.atv_status === 'fail';

      item.canResend =
        (vm.permissions.canUpdate &&
          vm.atvCrEnabled &&
          item.document_type.numbering_type === 'electronic' &&
          item.atv_status === 'not_sent') ||
        item.atv_status === 'pending' ||
        item.atv_status === 'sent' ||
        item.atv_status === 'received' ||
        item.atv_status === 'processing'; // fail ??

      item.canDownload =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            (item.atv_status === vm.statusAccepted || item.atv_status === vm.statusSent)));

      item.canNotify =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.atv_status === vm.statusAccepted));

      item.canAddPayment =
        vm.permissions.canUpdate &&
        (item.status === 'open' || item.status === 'overdue' || item.status === 'unpaid');
      item.canCreateCreditNote =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.atv_status === 'accepted'));
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        // startDate: '',
        // endDate: '',

        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
      };

      vm.dueDatePicker = {
        startDate: '',
        endDate: '',
      };

      vm.filterCriteria = BillService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );

      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

      // vm.filterCriteria.by_status     = 'unpaid';
      // vm.filterCriteria.by_status = vm.billStatuses[0].value;
      // vm.filterCriteria.by_atv_status = vm.atvCrStatuses[0].value;
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }

    function setDueDatePicker() {
      let filterByDueDate = (option) => {
        vm.filterCriteria.by_due_date_from = vm.UtilService.startOfDayFormat(
          vm.dueDatePicker.startDate
        );

        vm.filterCriteria.by_due_date_to = vm.UtilService.endOfDayFormat(vm.dueDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.dueDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDueDate,
        rangeOptions: config.DUE_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }
  }
})();
